import styles from '../Survey.module.scss'

interface IEndProps {
  translations: Map<string, string>
}

export const EndTemplate = ({ translations }: IEndProps) => {
  return (
    <div className={styles.endTemplate}>
      <div className={styles.endTemplate__image} />
      <div className={styles.endTemplate__header}>THANK YOU!</div>
      <div className={styles.endTemplate__desc}>{translations.get('thank-you-page')}</div>
    </div>
  )
}
